/* eslint-disable max-len */
import React from 'react'
import { ColorValue } from 'react-native'
import Svg, { Path } from 'react-native-svg'

interface StressManagementIconProps {
  size?: number
  strokeColor?: ColorValue
  strokeWidth?: number
  fillColor1?: ColorValue
  fillColor2?: ColorValue
}

const StressManagementIcon = ({
  size = 96,
  strokeColor = '#11494F',
  strokeWidth = 3,
  fillColor1 = '#8EA0A2',
  fillColor2 = '#416461',
}: StressManagementIconProps) => (
  <Svg viewBox="0 0 96 96" fill="none" stroke={strokeColor} width={size} height={size}>
    <Path
      d="M82.6409 54.5594C83.3812 49.5918 83.7528 44.5761 83.7528 39.5535V36.219C83.7528 33.3942 86.0426 31.1044 88.8926 31.1044C91.7145 31.1044 94.0018 33.3927 94.0003 36.2147L93.9871 56.5847C93.9838 62.9753 91.4436 69.1035 86.9247 73.6223L76.2816 84.2654V93.9997H53.4667C53.4667 93.9997 53.4468 79.6797 53.4428 78.2942C53.4304 74.026 55.121 69.9286 58.1534 66.8962C60.0037 65.0459 62.3184 63.7284 64.854 63.0822C67.2879 62.4618 69.5295 61.1926 71.3055 59.4164C72.6254 58.0963 74.2332 56.4884 75.6669 55.0543C77.7294 52.9913 81.0733 52.9917 83.1546 55.0727C85.2079 57.126 85.2075 60.4551 83.154 62.508L74.8327 70.8265"
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M13.3594 54.5594C12.6191 49.5918 12.2475 44.5761 12.2475 39.5535V36.219C12.2475 33.3942 9.95765 31.1044 7.1077 31.1044C4.28574 31.1044 1.9985 33.3927 2 36.2147L2.01314 56.5847C2.01652 62.9753 4.55667 69.1035 9.07557 73.6223L19.7187 84.2654V93.9997H42.5336C42.5336 93.9997 42.5535 79.6797 42.5575 78.2942C42.5699 74.026 40.8793 69.9286 37.8469 66.8962C35.9965 65.0459 33.6819 63.7284 31.1462 63.0822C28.7124 62.4618 26.4708 61.1926 24.6948 59.4164C23.3748 58.0963 21.7671 56.4884 20.3334 55.0543C18.2709 52.9913 14.927 52.9917 12.8457 55.0727C10.7924 57.126 10.7928 60.4551 12.8463 62.508L21.1676 70.8265"
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M76.5077 29.0902C76.5077 24.5439 73.8114 20.6298 69.9319 18.8523C71.3088 16.0296 70.8264 12.5287 68.4812 10.1835C66.6845 8.38685 64.2097 7.68446 61.8808 8.07217C61.1865 4.60885 58.1289 2 54.4614 2C51.7418 2 49.3583 3.4352 48.0241 5.58893C46.6899 3.4352 44.3063 2 41.5867 2C37.9192 2 34.8616 4.60885 34.167 8.07198C31.8382 7.68446 29.3632 8.38666 27.5666 10.1833C25.2213 12.5285 24.7392 16.0294 26.1158 18.8521C22.2364 20.6296 19.54 24.5437 19.54 29.09C19.54 33.6363 22.2364 37.5504 26.1158 39.3279C24.739 42.1506 25.2213 45.6514 27.5666 47.9967C29.3632 49.7933 31.838 50.4957 34.167 50.108C34.8615 53.5709 37.9191 56.18 41.5867 56.18C44.3063 56.18 46.6899 54.7448 48.0241 52.591C49.3583 54.7448 51.7418 56.18 54.4614 56.18C58.1289 56.18 61.1865 53.5711 61.8812 50.108C64.2099 50.4955 66.6849 49.7933 68.4815 47.9967C70.8268 45.6514 71.3089 42.1506 69.9323 39.3279C73.8115 37.5506 76.5077 33.6365 76.5077 29.0902Z"
      fill={fillColor1}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M57.2636 22.1466C54.7056 19.5887 50.5582 19.5887 48.0003 22.1466C45.4423 19.5887 41.2949 19.5887 38.737 22.1466C36.179 24.7046 36.179 28.8519 38.737 31.4099L48.0003 40.6729L57.2636 31.4097C59.8215 28.8519 59.8215 24.7046 57.2636 22.1466Z"
      fill={fillColor2}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M48.0239 5.58923V21.6073"
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M48.0239 40.6732V52.5911"
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

export default StressManagementIcon
